export const INDICATOR_DAY_INTERVAL_TYPE = {
    BUSINESS: 'BUSINESS',
    CALENDAR: 'CALENDAR',
} as const;

export type IndicatorDayIntervalType = (typeof INDICATOR_DAY_INTERVAL_TYPE)[keyof typeof INDICATOR_DAY_INTERVAL_TYPE];

export const PRIORITY_OPTIONS = Array.from({ length: 10 }).map((v, i) => ({ value: i + 1 }));

export const INDICATOR_COLOR_OPTIONS = {
    RED: 'red',
    ORANGE: 'orange',
    GREEN: 'green',
} as const;

export type IndicatorColor = (typeof INDICATOR_COLOR_OPTIONS)[keyof typeof INDICATOR_COLOR_OPTIONS];
